import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import { Spin } from 'antd';
import { prop } from 'ramda';

import { getMetroDepartmentChildren } from 'actions/asyncActions';

@withAsyncActions({
    getMetroDepartmentChildren: getMetroDepartmentChildren
        .withParams(prop('loadParams'))
        .withPayload(prop('loadParams'))
})
export default class MetroDepartmentTitle extends Component {
    componentDidMount() {
        this.props.getRef(this);
    }

    render() {
        const { item, getMetroDepartmentChildren } = this.props;

        return <span>
            { item.name } <Spin spinning={!!getMetroDepartmentChildren.meta.pending} wrapperClassName='select-spin' size='small' />
        </span>;
    }
}

export const MetroDepartmentChildrens = withAsyncActions({
    getMetroDepartmentChildren: getMetroDepartmentChildren
        .withParams(prop('loadParams'))
        .withPayload(prop('loadParams'))
})(({ children : RenderProp, getMetroDepartmentChildren }) => {
   <RenderProp getMetroDepartmentChildren={getMetroDepartmentChildren} />
})
